export enum Status {
    Completed = 1,
    Pending = 2,
    InProgress = 3,
    Scheduled = 4,
    Overdue = 5,
    Missed = 6,
}
